import { render } from "./FrontCommonStudentInfoBar.vue?vue&type=template&id=b5fa83d6&scoped=true"
import script from "./FrontCommonStudentInfoBar.vue?vue&type=script&lang=js"
export * from "./FrontCommonStudentInfoBar.vue?vue&type=script&lang=js"

import "./FrontCommonStudentInfoBar.vue?vue&type=style&index=0&id=b5fa83d6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Desktop\\project\\sparta\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5fa83d6"]])

export default __exports__